// Password rules shown on the Change Password page. These mirror the sign-up page's rules
// (@passport/auth-core passwordRequirements) and @passport/validators' validatePassword.

export interface PasswordRequirement {
  id: 'length' | 'uppercase' | 'lowercase' | 'number' | 'special';
  label: string;
  isMet: boolean;
}

export interface PasswordRequirementsResult {
  requirements: PasswordRequirement[];
  allMet: boolean;
}

const RULES: ReadonlyArray<{ id: PasswordRequirement['id']; label: string; test: (password: string) => boolean }> = [
  { id: 'length', label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { id: 'uppercase', label: '1 uppercase letter (A-Z)', test: (p) => /[A-Z]/.test(p) },
  { id: 'lowercase', label: '1 lowercase letter (a-z)', test: (p) => /[a-z]/.test(p) },
  { id: 'number', label: '1 number (0-9)', test: (p) => /\d/.test(p) },
  { id: 'special', label: '1 special character (@$!%*?&)', test: (p) => /[@$!%*?&]/.test(p) },
];

export const checkPasswordRequirements = (password: string): PasswordRequirementsResult => {
  const requirements = RULES.map(({ id, label, test }) => ({ id, label, isMet: test(password) }));
  return { requirements, allMet: requirements.every((r) => r.isMet) };
};
